import { configureBoneyard } from 'boneyard-js/react'

configureBoneyard({
  color: '#e5e7eb',
  darkColor: '#2f3440',
  animate: 'shimmer',
  shimmerColor: '#f8fafc',
  darkShimmerColor: '#485163',
  speed: '1.8s',
  shimmerAngle: 110,
  stagger: 40,
  transition: 180
})
